import { useState, useEffect } from 'react';

const isWindowAvailable = () => typeof window !== 'undefined';
function getInitialState(mediaQuery) {
  if (isWindowAvailable()) {
    // Clean up @media if present to ensure compatibility with theme.mediaQuery
    return window.matchMedia(mediaQuery.replace('@media', '')).matches;
  }
  return false;
}
const useMedia = mediaQuery => {
  const [matches, setMatches] = useState(getInitialState(mediaQuery));
  useEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQuery.replace('@media', ''));
    const onChange = () => {
      setMatches(mediaQueryList.matches);
    };
    mediaQueryList.addEventListener('change', onChange);
    setMatches(mediaQueryList.matches);
    return () => {
      mediaQueryList.removeEventListener('change', onChange);
    };
  }, [mediaQuery]);
  return matches;
};

export { useMedia };
//# sourceMappingURL=useMedia.js.map
